import React, { memo } from 'react';
// mui components
import { Switch as MuiSwitch, SwitchProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const MaterialNewUISwitch = styled(MuiSwitch)({
  width: 'unset',
  height: 'unset',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: '4px',
    '&.Mui-checked': {
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#4D6EF5',
      },
    },
    '&.Mui-disabled': {
      '& + .MuiSwitch-track': {
        opacity: 0.2,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: '12px',
    height: '12px',
    boxShadow: 'unset',
    backgroundColor: '#fff',
  },
  '& .MuiSwitch-track': {
    width: '40px',
    height: '20px',
    opacity: 1,
    backgroundColor: '#CED4DA',
    borderRadius: '40px',
  },
});

interface OwnProps extends SwitchProps {}

const Switch: React.FC<OwnProps> = (props) => {
  return <MaterialNewUISwitch {...props} />;
};
export default memo(Switch);
